// extracted by mini-css-extract-plugin
export var bodyRow = "_gj-d";
export var cardColumns = "_gj-e";
export var ellipsesOverflow = "_gj-2";
export var flatBottomCorners = "_gj-3";
export var flatTopCorners = "_gj-4";
export var headerActionsDropdown = "_gj-f";
export var headerBottomRow = "_gj-c";
export var headerTopRow = "_gj-b";
export var orderDetailsWrapper = "_gj-0";
export var orderInfoContainer = "_gj-1";
export var productDetails = "_gj-9";
export var productImage = "_gj-5";
export var responsiveTable = "_gj-8";
export var shipmentContainer = "_gj-a";
export var tableBottomLeft = "_gj-6";
export var tableBottomRight = "_gj-7";